import React from "react"
import history from "../routes/history"
import axios from "axios"
import { BASEURL, path } from "../core/utils"
import api from "../core/api"

const INIT_STATE = {
    documento: "",
    email: "",
    hash: "",
    senha: "",
    confirmSenha: "",
    step: 1,
    alert: ""
}

class RecuperarSenha extends React.Component {
    state = INIT_STATE

    doc(e) {
        let documento = e.target.value.replace(/\D/g, "")
        this.setState({ documento })
    }

    codigo(e) {
        let hash = e.target.value.replace(/\D/g, "")
        this.setState({ hash })
    }

    enviarCodigo() {
        let { documento, email } = this.state
        this.setState({
            alert: { type: "warning", message: "Aguarde..." }
        })
        api
            .post(BASEURL + "/clientes/recuperarSenha", { documento, email })
            .then(response => {
                this.setState({
                    step: 2,
                    alert: { type: "info", message: "Um código foi enviado para seu email." }
                })
            })
            .catch(err => {
                console.log(JSON.parse(JSON.stringify(err.response)))

                this.setState({ alert: { type: "red", message: err.response.data.message } })
            })
    }

    alterarSenha() {
        let { documento, senha, confirmSenha, hash } = this.state
        if (senha !== confirmSenha) {
            this.setState({
                senha: "",
                confirmSenha: "",
                alert: { type: "red", message: "As Senhas digitadas não são iguais!" }
            })
        } else {
            api
                .post(BASEURL + "/clientes/atualizarSenha", { documento, senha, hash })
                .then(response => {
                    this.setState({
                        step: 3,
                        alert: {
                            type: "success",
                            message: "Senha atualizada com sucesso!"
                        }
                    })
                })
                .catch(err => {
                    this.setState({ alert: { type: "red", message: err.response.data.message } })
                })
        }
    }
    step1() {
        return (
            <>
                <div className="field">
                    <label className="label">CPF/CNPJ:</label>
                    <div className="control">
                        <input
                            value={this.state.documento}
                            className="input"
                            type="text"
                            placeholder="Digite o CPF ou CNPJ"
                            onChange={e => this.doc(e)}
                        />
                    </div>
                </div>
                <div className="field">
                    <label className="label">Email:</label>
                    <div className="control">
                        <input
                            value={this.state.email}
                            className="input"
                            type="text"
                            placeholder="Digite seu email"
                            onChange={e => this.setState({ email: e.target.value })}
                        />
                    </div>
                </div>

                <div
                    className="field"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <button
                        className="button is-primary is-green"
                        onClick={() => this.enviarCodigo()}
                    >
                        Enviar
                    </button>

                    <button
                        className="button is-warning"
                        onClick={() => history.push(`${path}/login`)}
                    >
                        Cancelar
                    </button>
                </div>
            </>
        )
    }
    step2() {
        return (
            <>
                <div className="field">
                    <label className="label">Código:</label>
                    <div className="control">
                        <input
                            style={{ width: 80 }}
                            value={this.state.hash}
                            className="input"
                            type="text"
                            placeholder="99999"
                            onChange={e => this.codigo(e)}
                            maxLength="5"
                        />
                    </div>
                </div>
                <div className="field">
                    <label className="label">Nova Senha:</label>
                    <div className="control">
                        <input
                            value={this.state.senha}
                            className="input"
                            type="password"
                            placeholder="Digite sua nova senha"
                            onChange={e => this.setState({ senha: e.target.value })}
                        />
                    </div>
                </div>
                <div className="field">
                    <label className="label">Confirme Senha:</label>
                    <div className="control">
                        <input
                            value={this.state.confirmSenha}
                            className="input"
                            type="password"
                            placeholder="Confirme sua senha"
                            onChange={e => this.setState({ confirmSenha: e.target.value })}
                        />
                    </div>
                </div>
                <div
                    className="field"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <button
                        className="button is-primary is-green"
                        onClick={() => this.alterarSenha()}
                    >
                        Enviar
                    </button>
                </div>
            </>
        )
    }

    step3() {
        return (
            <div className="field">
                <button className="button is-link" onClick={() => this.goToLogin()}>
                    <i className="material-icons " style={{ color: "white", fontSize: 20 }}>
                        navigate_before
                    </i>
                    Logar
                </button>
            </div>
        )
    }
    goToLogin() {
        this.setState(INIT_STATE)
        history.push(`${path}/login`)
    }
    renderSteps() {
        switch (this.state.step) {
            case 1:
                return this.step1()
            case 2:
                return this.step2()
            case 3:
                return this.step3()
            default:
                break
        }
    }

    render() {
        return (
            <section className="root">
                <div className="login">
                    <div className="content-login card-info" style={{ width: "auto" }}>
                        <div style={{ display: "flex" }}>
                            <div style={{ width: 400, backgroundColor: "#f5f5f5", padding: 10 }}>
                                <div className="logo-login" />
                                <p
                                    className="has-text-green"
                                    style={{ fontWeight: "bold", fontSize: 20 }}
                                >
                                    Recuperação de Senha
                                </p>
                                <span style={{ fontSize: 14 }}>
                                    {this.state.step === 1
                                        ? `Para recupeara sua senha preencha as informações abaixo.`
                                        : `para recuperar sua senha digite o codigo de 5 digitos que foi
                                    enviado para seu email.`}
                                </span>
                                <br />
                                <br />
                                {this.state.alert && (
                                    <div
                                        className={`button alert is-${this.state.alert.type}`}
                                        style={{ marginBottom: 10 }}
                                    >
                                        {this.state.alert.message}
                                    </div>
                                )}
                                {this.renderSteps()}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default RecuperarSenha
